import { supabase } from "@/integrations/supabase/client";

export interface KeywordAssignment {
  id: string;
  keywordId: string;
  certificationId: string;
  chapterId: string;
  sortOrder: number;
}

type Listener = () => void;
let _items: KeywordAssignment[] = [];
let _loaded = false;
const listeners = new Set<Listener>();
const notify = () => listeners.forEach((fn) => fn());

export function rowToAssignment(r: any): KeywordAssignment {
  return {
    id: r.id,
    keywordId: r.keyword_id,
    certificationId: r.certification_id,
    chapterId: r.chapter_id ?? "",
    sortOrder: r.sort_order ?? 0,
  };
}

async function loadFromDb() {
  const { data } = await supabase.from("keyword_assignments" as any).select("*").order("sort_order");
  _items = (data ?? []).map(rowToAssignment);
  _loaded = true;
  notify();
}

loadFromDb();

export const keywordAssignmentStore = {
  get: () => _items,
  subscribe: (fn: Listener) => { listeners.add(fn); return () => listeners.delete(fn); },
  isLoaded: () => _loaded,
  reload: loadFromDb,

  async add(item: Omit<KeywordAssignment, "id">) {
    const { data, error } = await supabase.from("keyword_assignments" as any).insert({
      keyword_id: item.keywordId,
      certification_id: item.certificationId,
      chapter_id: item.chapterId,
      sort_order: item.sortOrder,
    }).select().single();
    if (!error && data) {
      _items = [..._items, rowToAssignment(data)];
      notify();
    }
    return { error };
  },

  async remove(id: string) {
    const { error } = await supabase.from("keyword_assignments" as any).delete().eq("id", id);
    if (!error) {
      _items = _items.filter((a) => a.id !== id);
      notify();
    }
  },

  async removeByKeywordAndCert(keywordId: string, certificationId: string, chapterId: string) {
    const { error } = await supabase
      .from("keyword_assignments" as any)
      .delete()
      .eq("keyword_id", keywordId)
      .eq("certification_id", certificationId)
      .eq("chapter_id", chapterId);
    if (!error) {
      _items = _items.filter(
        (a) => !(a.keywordId === keywordId && a.certificationId === certificationId && a.chapterId === chapterId)
      );
      notify();
    }
  },
};
